import { useSearchParams } from "react-router-dom";
import { useIntl } from "@leagueplatform/locales";
import { usePageViewAnalytics } from "@leagueplatform/analytics";
import { useDocumentTitle } from "@leagueplatform/web-common";
import { Masonry } from "@leagueplatform/masonry";
import { MASONRY } from "common/constants";
import { JourneyContentWrapper } from "components/journey-content-wrapper.component";
import { PageContentWrapper } from "components/page-content-wrapper.component";
import { PageHeader } from "components/page-header/page-header.component";

const SEARCH_PARAM_KEY = "searchParam";

export const CareLibrarySearchPage = () => {
  const [searchParams] = useSearchParams();
  const searchParam = searchParams.get(SEARCH_PARAM_KEY) ?? "";
  const { formatMessage } = useIntl();
  const searchExploreTitle = formatMessage({ id: "STR_SEARCH_EXPLORE" });

  usePageViewAnalytics({ screen_name: "care library search results" });
  useDocumentTitle(searchExploreTitle);

  return (
    <PageContentWrapper>
      <PageHeader
        variant="sub-page"
        mobileBand="none"
        headingText={searchExploreTitle}
      />
      <JourneyContentWrapper>
        <Masonry
          rootNodeId={MASONRY.ROOT_NODE_ID_CARE_LIBRARY_SEARCH}
          initialQueryParams={{ [SEARCH_PARAM_KEY]: searchParam }}
        />
      </JourneyContentWrapper>
    </PageContentWrapper>
  );
};
